(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    /* EXCENTRED: Die Warenkorb-App (iCart) übernimmt den Klick auf "In den Warenkorb" komplett – dadurch schließt
     das Theme sein Quick-Add-Fenster nicht mehr selbst. Sobald der Warenkorb-Drawer aufgeht, Fenster schließen. */
  (function () {
    if (window.__exQuickAddWatch) return;
    window.__exQuickAddWatch = true;

    function closeQuickAdd() {
      document.querySelectorAll('dialog.quick-add-modal[open]').forEach(function (dialog) {
        var host = dialog.closest('quick-add-dialog, dialog-component');
        if (host && typeof host.closeDialog === 'function') {
          host.closeDialog();
        } else {
          dialog.close();
        }
      });
    }

    function watch(drawer) {
      new MutationObserver(function () {
        if (drawer.classList.contains('ia-sliding-cart--active')) closeQuickAdd();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    var tries = 0;
    (function find() {
      var drawer = document.querySelector('.ia-sliding-cart');
      if (drawer) return watch(drawer);
      if (++tries < 60) setTimeout(find, 500);
    })();
  })();
  } catch(e) { console.error(e); }
})();

})();
